import React, { useState } from 'react'
import ClearIcon from "@mui/icons-material/Clear";
import { dateFilterStyle as styles } from './purchaseHistory.tailwind'
import { Tooltip } from '@mui/material'
import DatePickers from '../shared/Input/DatePicker/DatePicker';
import dayjs from "dayjs";

const DateFilters = ({ fromDate, toDate, setFromDate, setToDate, handleFilter, handleClearFilters, isApplyingFilter, disableFuture }) => {
    const isInvalidDate = (date) => date && !dayjs(date, "MM-DD-YYYY", true).isValid();

    const [prevFromDate, setPrevFromDate] = useState("");
    const [prevToDate, setPrevToDate] = useState("");
    const areDatesValid = !isInvalidDate(fromDate) && !isInvalidDate(toDate);
    const isSameDates = fromDate === prevFromDate && toDate === prevToDate;
    const isDisabled = !(fromDate || toDate) || isApplyingFilter || isSameDates || !areDatesValid;

    const onApplyClick = () => {
        setPrevFromDate(fromDate);
        setPrevToDate(toDate);
        if(handleFilter) {
            handleFilter();
        }
    };

    const handleClear = () => {
        if(handleClearFilters) {
            handleClearFilters();
        }
        setPrevFromDate("");
        setPrevToDate("");
    }

    const handleFromDateChange = (value) => {
        setFromDate(value);
    }
    
    const handleToDateChange = (value) => {
        setToDate(value);
    }

    return (
        <div className={styles.filter_section}>
            <div className={styles.date_filters}>
                <DatePickers value={fromDate} onChange={handleFromDateChange} maxDate={toDate} placeholder={"Select From Date"} disableFuture={disableFuture}/>
                <span className={styles.textBetween}>to</span>
                <DatePickers value={toDate} onChange={handleToDateChange} minDate={fromDate} placeholder={"Select To Date"} disableFuture={disableFuture} />
            </div>

            <div className={styles.buttonsContainer}>
                <button
                    onClick={onApplyClick}
                    className={`${styles.apply_button} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    disabled={isDisabled}
                >
                    {isApplyingFilter ? "Applying..." : "Apply"}
                </button>

                {(fromDate || toDate) && (
                    <Tooltip title="Clear" arrow>
                        <button
                            onClick={handleClear}
                            className={styles.clear_button}
                        >
                            <ClearIcon sx={{ fontSize: "14px" }} />
                        </button>
                    </Tooltip>
                )}
            </div>
        </div>
    )
}

export default DateFilters